module.exports = __webpack_public_path__ + "img/dragonsb-logo.cdd7ef3f.png";